import { render } from "./QuestionHeader.vue?vue&type=template&id=0ee1948a"
import script from "./QuestionHeader.vue?vue&type=script&lang=js"
export * from "./QuestionHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__